import axios from 'axios';

export const privateAxiosInstance = axios.create({
    baseURL: `${import.meta.env.VITE_API_HOST}api/`,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true'
    }
});

export const publicAxiosInstance = axios.create({
    baseURL: `${import.meta.env.VITE_API_HOST}api/`,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true'
    }
});
